import { Flex, Text } from '@chakra-ui/react';
import SearchInput from '@components/common/SearchInput';
import { fakePredictionPositions } from '@features/positions/predictions/fakeData';
import PositionDetailDialog from '@features/positions/predictions/PositionDetailDialog';
import PositionsTable from '@features/positions/predictions/PositionsTable';
import { PredictionPosition } from '@features/positions/predictions/types';
import { memo, useCallback, useMemo, useState } from 'react';

const PositionsTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPosition, setSelectedPosition] = useState<PredictionPosition | null>(null);

  const handleClear = useCallback(() => {
    setSearchQuery('');
  }, []);

  const handleRowClick = useCallback((position: PredictionPosition) => {
    setSelectedPosition(position);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setSelectedPosition(null);
  }, []);

  const filteredPositions = useMemo(() => {
    if (searchQuery.trim() === '') {
      return fakePredictionPositions;
    }
    const q = searchQuery.toLowerCase();
    return fakePredictionPositions.filter((p) => p.market.toLowerCase().includes(q));
  }, [searchQuery]);

  return (
    <Flex direction="column" gap={3}>
      <Flex direction="row" gap={2} alignItems="center" pt={3}>
        <SearchInput
          query={searchQuery}
          setQuery={setSearchQuery}
          onClear={handleClear}
          placeholder="Search"
          size="sm"
        />
      </Flex>
      {filteredPositions.length > 0 ? (
        <PositionsTable positions={filteredPositions} onRowClick={handleRowClick} />
      ) : (
        <Text color="text.secondary" fontSize="sm" textAlign="center" py={8}>
          No positions found.
        </Text>
      )}
      <PositionDetailDialog
        position={selectedPosition}
        open={selectedPosition != null}
        onClose={handleCloseDialog}
      />
    </Flex>
  );
};

export default memo(PositionsTab);
